import iconPath from '@/assets/device-icons/mac-mini.svg';

interface MacMiniIconProps {
  className?: string;
}

export const MacMiniIcon = ({ className = "h-5 w-5" }: MacMiniIconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="Mac Mini" 
      className={className}
    />
  );
};
